import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes with clsx
 * Handles conflicts by giving precedence to later classes
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}